export default "__VITE_ASSET__B1tXx_oe__"